// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3a1Ho","info":"info__21k4w","owner":"owner__1xBzt","bold":"bold__18pNl"};